export const WIRES_WORKFLOW_CONTAINER_TAG_NAME = 'wires-workflow-container';
